import { extractId } from 'data/projects/phase-entity';
import { DependencyTypesEnum, EntityType } from 'utils/date-shift';
export const getPhaseList = (phases)=>{
    const result = {};
    phases.forEach(({ projectPhaseId, projectPhaseName, startDate, dueDate, entityOrder, tasks, dependentProjectPhases, project })=>{
        var _ref;
        result[projectPhaseId] = {
            depth: 0,
            id: projectPhaseId,
            name: projectPhaseName,
            type: EntityType.Phase,
            startDate,
            dueDate,
            project: project.projectId,
            children: (_ref = entityOrder === null || entityOrder === void 0 ? void 0 : entityOrder.map(extractId)) !== null && _ref !== void 0 ? _ref : tasks.map((_task)=>{
                var _task_taskId;
                return (_task_taskId = _task.taskId) !== null && _task_taskId !== void 0 ? _task_taskId : _task;
            }),
            dependentOn: dependentProjectPhases === null || dependentProjectPhases === void 0 ? void 0 : dependentProjectPhases.map(({ projectPhaseId: dPhaseId, dependencyType, lag })=>({
                    id: dPhaseId,
                    dependencyType: dependencyType ? DependencyTypesEnum[dependencyType] : 2,
                    lag: lag !== null && lag !== void 0 ? lag : null
                }))
        };
        dependentProjectPhases === null || dependentProjectPhases === void 0 ? void 0 : dependentProjectPhases.forEach(({ projectPhaseId: dPhaseId, dependencyType, lag })=>{
            var _result_dPhaseId, _ref;
            var _result_dPhaseId1;
            result[dPhaseId] = {
                ...(_result_dPhaseId = result[dPhaseId]) !== null && _result_dPhaseId !== void 0 ? _result_dPhaseId : {},
                dependencyFor: [
                    ...(_ref = (_result_dPhaseId1 = result[dPhaseId]) === null || _result_dPhaseId1 === void 0 ? void 0 : _result_dPhaseId1.dependencyFor) !== null && _ref !== void 0 ? _ref : [],
                    {
                        id: projectPhaseId,
                        dependencyType: dependencyType ? DependencyTypesEnum[dependencyType] : 2,
                        lag: lag !== null && lag !== void 0 ? lag : null
                    }
                ]
            };
        });
    });
    return result;
};
export const getTaskList = (tasks, phaseList)=>{
    const result = {};
    tasks.forEach(({ taskId, startDate, dueDate, subTasks, dependentTasks, parentTask, projectPhase, taskName, private: isPrivate, project })=>{
        var _result_taskId;
        result[taskId] = {
            ...(_result_taskId = result[taskId]) !== null && _result_taskId !== void 0 ? _result_taskId : {},
            depth: 1,
            name: taskName,
            id: taskId,
            type: EntityType.Task,
            hasStartDate: !!startDate,
            hasDueDate: !!dueDate,
            startDate,
            dueDate,
            project,
            children: subTasks === null || subTasks === void 0 ? void 0 : subTasks.map((_task)=>_task),
            parent: parentTask !== null && parentTask !== void 0 ? parentTask : projectPhase === null || projectPhase === void 0 ? void 0 : projectPhase.projectPhaseId,
            projectPhaseId: projectPhase === null || projectPhase === void 0 ? void 0 : projectPhase.projectPhaseId,
            isPrivate
        };
        dependentTasks === null || dependentTasks === void 0 ? void 0 : dependentTasks.filter(Boolean).forEach(({ taskId: dTaskId, dependencyType, lag })=>{
            if (dependencyType !== undefined && dependencyType !== null) {
                var _result_dTaskId, _ref, _result_taskId, _ref1;
                var _result_dTaskId1, _result_taskId1;
                result[dTaskId] = {
                    ...(_result_dTaskId = result[dTaskId]) !== null && _result_dTaskId !== void 0 ? _result_dTaskId : {},
                    dependencyFor: [
                        ...(_ref = (_result_dTaskId1 = result[dTaskId]) === null || _result_dTaskId1 === void 0 ? void 0 : _result_dTaskId1.dependencyFor) !== null && _ref !== void 0 ? _ref : [],
                        {
                            id: taskId,
                            dependencyType: dependencyType ? DependencyTypesEnum[dependencyType] : 2,
                            lag: lag !== null && lag !== void 0 ? lag : null
                        }
                    ]
                };
                result[taskId] = {
                    ...(_result_taskId = result[taskId]) !== null && _result_taskId !== void 0 ? _result_taskId : {},
                    dependentOn: [
                        ...(_ref1 = (_result_taskId1 = result[taskId]) === null || _result_taskId1 === void 0 ? void 0 : _result_taskId1.dependentOn) !== null && _ref1 !== void 0 ? _ref1 : [],
                        {
                            id: dTaskId,
                            dependencyType: dependencyType ? DependencyTypesEnum[dependencyType] : 2,
                            lag: lag !== null && lag !== void 0 ? lag : null
                        }
                    ]
                };
            }
        });
    });
    const getDepth = (id)=>{
        var _result_id;
        return !((_result_id = result[id]) === null || _result_id === void 0 ? void 0 : _result_id.parent) ? 0 : getDepth(result[id].parent) + 1;
    };
    const getStartDate = (id)=>{
        var _this, _this1;
        const startDateValue = (_this = result[id] || phaseList[id]) === null || _this === void 0 ? void 0 : _this.startDate;
        const parent = (_this1 = result[id] || phaseList[id]) === null || _this1 === void 0 ? void 0 : _this1.parent;
        return startDateValue || parent && getStartDate(parent);
    };
    Object.values(result).forEach((_task)=>{
        result[_task.id] = {
            ..._task,
            depth: getDepth(_task.id)
        };
    });
    Object.values(result).filter((_task)=>!_task.startDate).forEach((_task)=>{
        result[_task.id] = {
            ..._task,
            startDate: _task.dueDate || getStartDate(_task.id)
        };
    });
    Object.values(result).filter((_task)=>!_task.dueDate).forEach((_task)=>{
        result[_task.id] = {
            ..._task,
            dueDate: _task.startDate
        };
    });
    return result;
};
export const getSprintList = (sprints, phaseList)=>{
    const result = {};
    sprints.forEach(({ sprintId, startDate, dueDate, projectPhase, sprintName })=>{
        var _result_sprintId;
        var _phaseList_projectPhase_projectPhaseId;
        result[sprintId] = {
            ...(_result_sprintId = result[sprintId]) !== null && _result_sprintId !== void 0 ? _result_sprintId : {},
            depth: 1,
            name: sprintName,
            id: sprintId,
            type: EntityType.Sprint,
            hasStartDate: !!startDate,
            hasDueDate: !!dueDate,
            startDate,
            dueDate,
            children: [],
            dependentOn: [],
            parent: projectPhase === null || projectPhase === void 0 ? void 0 : projectPhase.projectPhaseId,
            projectPhaseId: projectPhase === null || projectPhase === void 0 ? void 0 : projectPhase.projectPhaseId,
            project: (projectPhase === null || projectPhase === void 0 ? void 0 : projectPhase.projectPhaseId) ? (_phaseList_projectPhase_projectPhaseId = phaseList[projectPhase.projectPhaseId]) === null || _phaseList_projectPhase_projectPhaseId === void 0 ? void 0 : _phaseList_projectPhase_projectPhaseId.project : undefined
        };
    });
    const getStartDate = (id)=>{
        var _this, _this1;
        const startDateValue = (_this = result[id] || phaseList[id]) === null || _this === void 0 ? void 0 : _this.startDate;
        const parent = (_this1 = result[id] || phaseList[id]) === null || _this1 === void 0 ? void 0 : _this1.parent;
        return startDateValue || parent && getStartDate(parent);
    };
    const updatedResult = Object.values(result).reduce((acc, _sprint)=>{
        let sprint = _sprint;
        if (!sprint.startDate) {
            const startDateValue = sprint.dueDate || getStartDate(sprint.id);
            sprint = {
                ...sprint,
                startDate: startDateValue
            };
        }
        if (!sprint.dueDate) {
            sprint = {
                ...sprint,
                dueDate: sprint.startDate
            };
        }
        acc[sprint.id] = sprint;
        return acc;
    }, {});
    return updatedResult;
};
export const filterTaskUpdates = (taskUpdates, _tasks)=>{
    const filteredUpdates = {};
    Object.values(taskUpdates).forEach((update)=>{
        const { id } = update;
        const _update = {
            ...update
        };
        const task = _tasks.find((_task)=>_task.taskId === id);
        if (!(task === null || task === void 0 ? void 0 : task.startDate) && _update.startDate) {
            delete _update.startDate;
        }
        if (!(task === null || task === void 0 ? void 0 : task.dueDate) && _update.dueDate) {
            delete _update.dueDate;
        }
        filteredUpdates[id] = {
            ..._update
        };
    });
    return filteredUpdates;
};
export const getParentStartDate = (id, lookup)=>{
    const { startDate, parent } = lookup[id];
    return parent && lookup[parent].startDate ? lookup[parent].startDate : parent && getParentStartDate(parent, lookup) ? getParentStartDate(parent, lookup) : startDate;
};
export const normaliseTasks = (tasks)=>{
    return tasks.map((task)=>{
        const { subTasks, project, ...rest } = task;
        return {
            ...rest,
            subTasks: subTasks === null || subTasks === void 0 ? void 0 : subTasks.map(({ taskId })=>taskId),
            project: project.projectId
        };
    });
};
